'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import cl from 'clsx/lite';
import { forwardRef, useId, useContext } from 'react';
import { ToggleGroupContext } from './toggle-group.js';

/**
 * A single item in a ToggleGroup.
 * @example
 * <ToggleGroupItem value='1'>Toggle 1</ToggleGroupItem>
 */
const ToggleGroupItem = forwardRef(function ToggleGroupItem({ className, children, icon, value: rawValue, ...rest }, ref) {
    const genValue = useId();
    const toggleGroup = useContext(ToggleGroupContext);
    const value = rawValue ?? genValue;
    const active = toggleGroup.value === value;
    const { form, formAction, formEncType, formMethod, formNoValidate, formTarget, required, disabled, 'aria-disabled': ariaDisabled, ...labelProps } = rest;
    /** Add backwards compatibility for `button` props that were previously allowed on `ToggleGroupItem` but are passeable to `input`*/
    const inputProps = {
        form,
        formAction,
        formEncType,
        formMethod,
        formNoValidate,
        formTarget,
        required,
        disabled,
        'aria-disabled': ariaDisabled,
    };
    return (jsxs("label", { ref: ref, ...labelProps, className: cl('ds-button', className), "data-variant": 'tertiary', "aria-disabled": ariaDisabled ?? disabled, children: [jsx("input", { ...inputProps, checked: active, name: toggleGroup.name, onChange: () => toggleGroup.onChange?.(value), type: 'radio', value: value, disabled: disabled, "aria-disabled": ariaDisabled }), children] }));
});

export { ToggleGroupItem };
